export default {
  addItem: {
    position: 'absolute',
    right: 200,
    top: 35,
    zIndex: 1100,
  },
  noDataRow: {
    textAlign: 'center',
    color: 'lightgrey',
    fontSize: 24,
  },
  noData: {
    fontSize: 250,
    color: 'lightgrey',
  },
  stages: {
    display: 'flex',
    flexDirection: 'row',
  },
  chip: {
    margin: 5,
  },
  nameCol: {
    width: 250,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
};



// WEBPACK FOOTER //
// ./src/components/JobProfiles/styles.js